"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.number.constructor");

var _send = require("@/api/cms/send");

var _exceljs = _interopRequireDefault(require("exceljs"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = {
  name: 'DeliveryActions',
  props: {
    id: {
      type: [String, Number],
      default: null
    },
    editId: {
      type: [String, Number],
      default: null
    },
    detailId: {
      type: [String, Number],
      default: null
    },
    deliveryNo: {
      type: String,
      default: ''
    },
    sendTaskId: {
      type: [String, Number],
      default: null
    },
    sendStatus: {
      type: Number,
      default: null
    },
    prevStatus: {
      type: Number,
      default: 0
    },
    canOperate: {
      type: Boolean,
      default: false
    },
    showStepBack: {
      type: Boolean,
      default: false
    },
    showRemind: {
      type: Boolean,
      default: false
    },
    contractList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    deliveryType: {
      type: String,
      default: '配送(到家)'
    }
  },
  data: function data() {
    return {
      reminding: false,
      remindReadStatus: null,
      _checkingRemind: false
    };
  },
  computed: {
    remindLabel: function remindLabel() {
      if (this.remindReadStatus === 1) return '已读';
      if (this.remindReadStatus === 0) return '已催办';
      return '催办';
    },
    resolveId: function resolveId() {
      return this.editId || this.detailId || this.id;
    }
  },
  watch: {
    resolveId: {
      immediate: true,
      handler: function handler() {
        this.checkReminded();
      }
    }
  },
  mounted: function mounted() {
    this.checkReminded();
  },
  methods: {
    handleRemind: function handleRemind() {
      var _this = this;

      if (this.reminding) return;
      var id = this.resolveId;

      if (!id) {
        this.$message.error('未找到发货单ID');
        return;
      }

      this.$confirm('确定要发送催办消息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this.reminding = true;
        (0, _send.remindSend)(id).then(function (res) {
          if (res.code === 200) {
            _this.$message.success('催办消息已发送');

            _this.remindReadStatus = 0;
          } else {
            _this.$message.error(res.msg || '催办失败');
          }
        }).catch(function () {
          _this.$message.error('催办失败，请重试');
        }).finally(function () {
          _this.reminding = false;
        });
      }).catch(function () {});
    },
    checkReminded: function checkReminded() {
      var _this2 = this;

      var id = this.resolveId;
      if (this._checkingRemind || !id || this.sendStatus == null) return;
      this._checkingRemind = true;
      (0, _send.checkRemindStatus)(id, this.sendStatus).then(function (res) {
        if (res.code === 200) {
          var status = res.data != null ? res.data : null;
          _this2.remindReadStatus = status;

          if (status === 0) {
            (0, _send.markRemindRead)(id, _this2.sendStatus).then(function (readRes) {
              if (readRes.code === 200) {
                _this2.remindReadStatus = 1;
              }
            }).catch(function () {});
          }
        }
      }).catch(function () {}).finally(function () {
        _this2._checkingRemind = false;
      });
    },
    handleCommand: function handleCommand(command) {
      var id = this.resolveId;

      if (!id) {
        this.$message.error('未找到发货单ID');
        return;
      }

      if (command === 'revoke') {
        this.doRevoke(id);
      } else if (command.startsWith('stepBack:')) {
        var targetStatus = parseInt(command.split(':')[1]);
        this.doStepBack(id, targetStatus);
      } else if (command === 'shipmentNote') {
        this.exportShipmentNote();
      }
    },
    doRevoke: function doRevoke(id) {
      var _this3 = this;

      this.$confirm('确定撤销该发货单？撤销后派单信息可重新编辑。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _send.deleteSend)(id).then(function (res) {
          if (res.code === 200) {
            _this3.$message.success('已撤销，可重新编辑');

            _this3.$emit('revoked');
          } else {
            _this3.$message.error(res.msg || '撤销失败');
          }
        }).catch(function () {
          _this3.$message.error('撤销失败，请重试');
        });
      }).catch(function () {});
    },
    doStepBack: function doStepBack(id, targetStatus) {
      var _this4 = this;

      var statusLabels = {
        '-1': '预约异常',
        10: '待预约',
        20: '待装车',
        30: '待到达',
        40: '待送达',
        50: '待核算',
        60: '已核算',
        1010: '待审核',
        1020: '待打单',
        1030: '待备货',
        1040: '待发货',
        1050: '已发货'
      };
      var currentLabel = statusLabels[this.sendStatus] || this.sendStatus;
      var targetLabel = statusLabels[targetStatus] || targetStatus;
      this.$confirm("\u786E\u5B9A\u9000\u56DE\u4E0A\u4E00\u7EA7\uFF1F\u5C06\u4ECE\"".concat(currentLabel, "\"\u9000\u56DE\u81F3\"").concat(targetLabel, "\"\u3002"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _send.submitSend)(id, targetStatus, 1).then(function (res) {
          if (res.code === 200) {
            _this4.$message.success("\u5DF2\u9000\u56DE\u81F3\"".concat(targetLabel, "\""));

            _this4.$emit('step-back', targetStatus);
          } else {
            _this4.$message.error(res.msg || '退回失败');
          }
        }).catch(function () {
          _this4.$message.error('退回失败，请重试');
        });
      }).catch(function () {});
    },
    exportShipmentNote: function exportShipmentNote() {
      if (!this.contractList || this.contractList.length === 0) {
        this.$message.warning('没有可导出的订单数据');
        return;
      }

      var loading = this.$loading({
        lock: true,
        text: '正在生成出货单...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      var deliveryNo = '发货单据号：' + (this.deliveryNo || '');
      var companyName = '广西爱阁工房家居有限责任公司';
      var headers = ['序号', '订单号', '产品名称', '石材材料', '石材颜色', '入库状态', '齐套日期', '面积', '体积', '石材米', '总包数', '未包数', '已包数', '入库数'];
      var workbook = new _exceljs.default.Workbook();
      var worksheet = workbook.addWorksheet('出货单');

      function colToLetter(col) {
        var letter = '';

        while (col > 0) {
          var mod = (col - 1) % 26;
          letter = String.fromCharCode(65 + mod) + letter;
          col = Math.floor((col - 1) / 26);
        }

        return letter;
      }

      var endCol = colToLetter(headers.length);
      worksheet.mergeCells('A1:' + endCol + '1');
      worksheet.mergeCells('A2:' + endCol + '2');
      var companyCell = worksheet.getCell('A1');
      companyCell.value = companyName;
      companyCell.font = {
        size: 20,
        bold: true
      };
      companyCell.alignment = {
        horizontal: 'center',
        vertical: 'middle'
      };
      var deliveryCell = worksheet.getCell('A2');
      deliveryCell.value = deliveryNo;
      deliveryCell.font = {
        size: 14,
        bold: true
      };
      deliveryCell.alignment = {
        horizontal: 'center',
        vertical: 'middle'
      };
      worksheet.addRow(headers);
      this.contractList.forEach(function (item, index) {
        var rowData = [index + 1, item.productionOrder || '', item.solutionName || '', item.stoneMaterial || '', item.stoneColor || '', item.storageStatus || '', item.inTime || '', item.area != null ? item.area : '', item.volume != null ? item.volume : '', item.stoneLength != null ? item.stoneLength : '', item.packages != null ? item.packages : '', item.unpackedCount != null ? item.unpackedCount : '', item.packedCount != null ? item.packedCount : '', item.storageCount != null ? item.storageCount : ''];
        worksheet.addRow(rowData);
      });

      function getDisplayWidth(str) {
        if (!str && str !== 0) return 0;
        str = String(str);
        var width = 0;

        for (var i = 0; i < str.length; i++) {
          width += str.charCodeAt(i) > 255 ? 2.2 : 1.1;
        }

        return width;
      }

      var colMaxWidths = {};

      for (var c = 1; c <= headers.length; c++) {
        colMaxWidths[c] = 0;
      }

      worksheet.eachRow({
        includeEmpty: false
      }, function (row) {
        row.eachCell(function (cell, colNumber) {
          var w = getDisplayWidth(cell.value);

          if (w > colMaxWidths[colNumber]) {
            colMaxWidths[colNumber] = w;
          }
        });
      });
      worksheet.columns.forEach(function (col, i) {
        col.width = Math.max(colMaxWidths[i + 1] + 1, 4);
      });
      worksheet.eachRow({
        includeEmpty: false
      }, function (row, rowNumber) {
        if (rowNumber === 1) {
          row.height = 50;
        } else if (rowNumber === 2) {
          row.height = 30;
        } else {
          row.height = 24;
        }

        row.eachCell(function (cell) {
          cell.alignment = {
            horizontal: 'center',
            vertical: 'middle'
          };
          cell.border = {
            top: {
              style: 'thin'
            },
            left: {
              style: 'thin'
            },
            bottom: {
              style: 'thin'
            },
            right: {
              style: 'thin'
            }
          };
        });
      });
      var self = this;
      workbook.xlsx.writeBuffer().then(function (buffer) {
        var blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        var url = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = url;
        link.download = '出货单_' + (self.deliveryNo || '') + '.xlsx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        loading.close();
        self.$message.success('出货单导出成功');
      }).catch(function () {
        loading.close();
        self.$message.error('出货单导出失败');
      });
    }
  }
};
exports.default = _default2;